import { BrowserRouter, Route, Routes as RouterRoutes } from 'react-router-dom';

import About from './pages/about';
import AdminRoutes from './pages/admin';
import AttorneysPage from './pages/attorneys';
import CareersPage from './pages/careers';
import Contact from './pages/contact';
import ErrorBoundary from 'components/ErrorBoundary';
import Homepage from './pages/homepage';
import NotFound from 'pages/NotFound';
import PracticeAreas from './pages/practice-areas';
import Publications from './pages/publications';
import React from 'react';
import ScrollToTop from 'components/ScrollToTop';

const Routes = () => {
	return (
		<BrowserRouter>
			<ErrorBoundary>
				<ScrollToTop />
				<RouterRoutes>
					{/* Public Routes */}
					<Route path='/' element={<Homepage />} />
					<Route path='/contact' element={<Contact />} />
					<Route path='/attorneys' element={<AttorneysPage />} />
					<Route path='/publications' element={<Publications />} />
					<Route path='/practice-areas' element={<PracticeAreas />} />
					<Route path='/about' element={<About />} />
					<Route path='/careers' element={<CareersPage />} />

					{/* Admin Routes */}
					<Route path='/admin/*' element={<AdminRoutes />} />

					{/* 404 Route */}
					<Route path='*' element={<NotFound />} />
				</RouterRoutes>
			</ErrorBoundary>
		</BrowserRouter>
	);
};

export default Routes;
